import { createAction } from '@ngrx/store';
import { MapPositionerResult } from '@spog-ui/shared/models/map-positioners';

export const retrySavingPositionsAction = createAction(
  '[Map Positioner Toast] Retry Saving Positions',
  (result: MapPositionerResult) => ({ result }),
);
